import axios from 'axios';
import { authService } from './auth.service';

// Определяем API URL в зависимости от окружения
const getApiUrl = () => {
  // В production используем REACT_APP_PRODUCTION_API_URL, если она указана
  if (process.env.NODE_ENV === 'production' && process.env.REACT_APP_PRODUCTION_API_URL) {
    return process.env.REACT_APP_PRODUCTION_API_URL;
  }
  // В остальных случаях используем REACT_APP_API_URL или дефолтное значение
  return process.env.REACT_APP_API_URL || 'http://localhost:3000';
};

const api = axios.create({
  baseURL: getApiUrl(),
  headers: {
    'Content-Type': 'application/json',
  },
});

// Интерсептор для добавления токена авторизации
api.interceptors.request.use(
  (config) => {
    const token = authService.getToken();
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

// Интерсептор для обработки ошибок
api.interceptors.response.use(
  (response) => response,
  (error) => {
    // Игнорируем 401 на эндпоинте логина (это ожидаемое поведение при неверных данных)
    const isLoginEndpoint = error.config?.url?.includes('/auth/login');

    if (error.response?.status === 401 && !isLoginEndpoint) {
      // Только для остальных эндпоинтов очищаем данные и редиректим
      authService.logout();
      window.location.href = '/login';
    }
    return Promise.reject(error);
  }
);

export default api;
